export function isDot(char: string): boolean
{
  return char === '.'
}